module.exports = __webpack_public_path__ + "static/assets/492d7231440a10ed25704de0aea7be2e.png";